import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const features = [
  {
    icon: FiIcons.FiQrCode,
    title: "Zero-Friction Access",
    description: "No apps, no logins, no friction. Guests simply scan a unique QR code and start sharing their perspective instantly from any mobile browser."
  },
  {
    icon: FiIcons.FiZap,
    title: "Real-Time Live Sync",
    description: "Watch your event gallery grow in real-time. Photos appear instantly in the cloud, allowing for live slideshows that keep the energy high."
  },
  {
    icon: FiIcons.FiShield,
    title: "Private & Secure",
    description: "Your memories stay yours. Create a closed, private social network where only invited guests can see, share, and interact with content."
  },
  {
    icon: FiIcons.FiDownload,
    title: "Original Quality Storage",
    description: "Stop chasing low-res screenshots. Download every guest photo and video in its full, uncompressed original quality for professional use."
  },
  {
    icon: FiIcons.FiMonitor,
    title: "Live Memory Walls",
    description: "Turn any TV or projector into a live engagement hub. Stream guest uploads in a beautiful, automated slideshow as the event unfolds."
  },
  {
    icon: FiIcons.FiLayout,
    title: "Custom Event Branding",
    description: "Make it yours. Customize your gallery theme, colors, and custom domain to perfectly align with your event's unique branding and vibe."
  },
  {
    icon: FiIcons.FiMessageSquare,
    title: "Guest Interactions",
    description: "Enable likes and comments to turn your gallery into a vibrant community. Let guests connect over shared moments long after the event ends."
  },
  {
    icon: FiIcons.FiClock,
    title: "Instant Setup",
    description: "Go live in under 2 minutes. Our intuitive dashboard makes it incredibly simple to launch your event and generate your first QR code."
  }
];

const LandingFeatures = () => {
  return (
    <section id="features" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold text-indigo-600 tracking-wide uppercase">The Memories Edge</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Everything you need for a connected event
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
            We've built the ultimate tool for event organizers to capture every angle of the celebration without the technical headache.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative p-8 bg-white rounded-2xl hover:shadow-xl transition-all duration-300 border border-gray-100 group"
            >
              <div className="mb-6 inline-flex items-center justify-center p-3 bg-indigo-600 rounded-xl shadow-lg group-hover:scale-110 transition-transform">
                <SafeIcon icon={feature.icon} className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingFeatures;